export class UserRecover {
  constructor(public email?: string) {
  }
}
